import service from '@/store/services/lessons-service';

const state = {
  list: {},
  lesson: {},
  meta: {},
  doneMonth:null,
  doneWeek:null,
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_DONE_MONTH: (state, count) => {
    state.doneMonth = count;
  },
  SET_DONE_WEEK: (state, count) => {
    state.doneWeek = count;
  },
  SET_RESOURCE: (state, lesson) => {
    state.lesson = lesson;
  },
//   SET_META: (state, meta) => {
//     state.meta = meta;
//   }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list}) => {
        commit('SET_LIST', list);
      });
  },

  countLessonMonth({commit, dispatch}, params) {
    return service.countLessonMonth(params)
      .then(({count}) => {
        commit('SET_DONE_MONTH', count);
      });
  },

  countLessonWeek({commit, dispatch}, params) {
    return service.countLessonWeek(params)
      .then(({count}) => {
        commit('SET_DONE_WEEK', count);
      });
  },

//   deleted({commit, dispatch}, params) {
//     return service.list(params)
//       .then(({list}) => {
//         commit('SET_DELETED_LIST', list);
//       });
//   },

//   get({commit, dispatch}, params) {
//     return service.get(params)
//       .then((user) => { commit('SET_RESOURCE', user); });
//   },

  add({commit, dispatch}, params) {
    return service.add(params);
  },

//   addAsAdmin({commit, dispatch}, params) {
//     return service.addAsAdmin(params)
//       .then((user) => { commit('SET_RESOURCE', user); });
//   },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((lesson) => { commit('SET_RESOURCE', lesson); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

//   enable({commit, dispatch}, params) {
//     return service.enable(params);
//   },

//   resetPassword({commit, dispatch}, params) {
//     return service.resetPassword(params);
//   }
};

const getters = {
  list: state => state.list,
  doneMonth: state => state.doneMonth,
  doneWeek: state => state.doneWeek,
//   listTotal: state => state.meta.page.total,
//   user: state => state.user,
//   students: state => state.students,
//   teachers: state => state.teachers,
//   deletedList: state => state.deletedList,
};

const lessons = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default lessons;
